import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { AutocompleteSettings } from '../../models/autocomplete-settings.model';
import { UtilityFunctions } from '../../utilities/functions.models';

@Component({
  standalone: false,
  selector: 'bt-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnChanges {

  @Input() public datasource: any[];
  @Input() public currentSelected: any;
  @Input() public settings: AutocompleteSettings;
  @Input() public disabledProperty: boolean;
  @Input() public page: number;
  @Input() public loaderId: string;

  @Output() public selected = new EventEmitter<any>();
  @Output() public nextPage = new EventEmitter<any>();
  @Output() public filterChange = new EventEmitter<string>();
  @Output() public open = new EventEmitter<any>();

  public showOptions: boolean;
  public valueToView: string;
  public datasourceCopy: any[];
  public searchText: string;
  public inputOnHover: boolean;
  public bottomHalf: boolean;

  private inputTimeout: any;

  @HostListener('window:click')
  public keyUpEvent() {
    if (!this.inputOnHover) this.showOptions = false;
  }

  public ngOnChanges(changes: SimpleChanges) {
    const primitive = this.settings.stringsDs;
    const valueProp = this.settings.valueProperty;
    if (this.settings && (primitive || !!valueProp)) {
      if (changes.datasource) {
        this.datasourceCopy = UtilityFunctions.DeepClone(this.datasource);
        if (this.currentSelected && (!this.datasource || !this.datasource.some(x => (primitive && x === this.currentSelected) || (!primitive && x[valueProp] === this.currentSelected[valueProp])))) {
          this.onClearSelected();
        }
      }
      if (changes.currentSelected) {
        this.setValueToView();
      }
    } else {
      this.onClearSelected();
    }
  }

  public onClearSelected(ev?: any) {
    if (ev) ev.stopPropagation();
    this.currentSelected = null;
    this.selected.emit(this.currentSelected);
    this.setValueToView();
  }

  public onClickInput(ev: any) {
    if (!this.disabledProperty) {
      this.showOptions = !this.showOptions;
      if (this.showOptions) {
        this.open.emit();
        this.bottomHalf = ev.clientY > window.innerHeight / 2;
      }
    }
  }

  public onFilterChange() {
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      this.settings.serverPagination ?
        this.filterChange.emit(this.searchText) :
        this.filterDs();
    }, 500);
  }

  public onSelect(event: Event, item: any) {
    event.stopPropagation();
    this.currentSelected = item;
    this.selected.emit(this.currentSelected);
    this.setValueToView();
    this.showOptions = false;
  }

  public inViewportAction(ev: { isVisible: boolean }, item: any) {
    if (ev.isVisible && this.settings.serverPagination) {
      const primitive = this.settings.stringsDs;
      const valueProp = this.settings.valueProperty;
      const index = this.datasourceCopy.findIndex(el => (primitive && item === el) || (!primitive && valueProp && item[valueProp] === el[valueProp]));
      //if (index === this.datasource.length - 1 && this.datasource.length / this.settings.paginationSize === this.page + 1) {
      if (index === this.datasource.length - 1 && this.datasource.length % this.settings.paginationSize! === 0) {
      this.nextPage.emit();
    }
  }
}

  private setValueToView() {
  this.valueToView = !this.currentSelected ? null : this.settings.stringsDs ? this.currentSelected : this.currentSelected[this.settings.textProperty];
}

  private filterDs() {
  if (this.datasource && !this.settings.serverPagination) {
    const primitive = this.settings.stringsDs;
    const textProp = this.settings.textProperty;
    const search = this.searchText ? this.searchText.toLowerCase() : '';
    this.datasourceCopy = UtilityFunctions.DeepClone(this.datasource.filter(el => {
      const field: string = primitive ? el : el[textProp];
      return field.toLowerCase().indexOf(search) >= 0;
    }));
  }
}
}
